import { SettingConst } from '@faire/web-api--source/types';

/**
 * If true, enables the holiday spend challenge for the retailer.
 * https://www.notion.so/faire/Holiday-Spend-Challenge-Eng-Spec-2462efb5c25a804dbf0cd3f3095e4eef#2462efb5c25a8137ac05c2dcb6536191
 */
export const HOLIDAY_SPEND_CHALLENGE_ENABLED_250807 =
  'HOLIDAY_SPEND_CHALLENGE_ENABLED_250807' as SettingConst<
    'HOLIDAY_SPEND_CHALLENGE_ENABLED_250807',
    boolean,
    'RETAILER' | 'RETAILER_IOS' | 'RETAILER_ANDROID' | 'HELP_CENTER'
  >;
